import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatDate = (value: string | Date) => format(new Date(value), "dd/MM/yyyy", { locale: ptBR });
export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
export const getInitials = (name: string) =>
  name.split(" ").filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join("");
